import React from 'react';
import Container from '../../UI/Container/Container';
import './NoResults.css';


const NoResults = (props) => {

    let conditionalContent = null;
    
    if(props.results.zeroResultsId === 1){  
        conditionalContent = <div className="tsg-no-shipping">
            <p>Message: <em>{props.results.zeroResultsMessage}</em></p>
            <p>Aren't we able to calculate the route you're interested in? Contact us.</p>
        </div>;
    }
    if(props.results.zeroResultsId === 2){
        conditionalContent = <div className="tsg-no-shipping">
            <p>Message: <em>{props.results.zeroResultsMessage}</em></p>
            <p>Aren't we able to calculate the route you're interested in? Contact us.</p>
        </div>;
    }
    if(props.results.zeroResultsId === 3){
        conditionalContent = <div className="tsg-no-shipping">
            <p>Message: <em>{props.results.zeroResultsMessage}</em></p>
            <p>Aren't we able to calculate the route you're interested in? Contact us.</p>    
        </div>;
    }
    return (
        <div className="no-results-container">
            <section className="tsg-from-to-timeline">
                <div className="tsg-timeline-container">
                    <span className="tsg-timeline-start">{props.fromDestination.address}</span>
                    <div className="tsg-timeline">
                        <div className="tsg-timeline-circle"></div>
                        <div className="tsg-timeline-line"></div>
                        <div className="tsg-timeline-circle end-circle"></div>
                    </div>
                    <span className="tsg-timeline-end">{props.toDestination.address}</span>
                </div>
            </section>
            <Container>
                <h2>Thorshipping Group</h2>
                {conditionalContent}

            </Container>
            <section className="tsg-actions-no-results">
                <Container>    
                    <div className="tsg-actions-buttons">
                        <a href="/" className="tsg-button">Contact us</a>
                    </div>
                </Container>
            </section>      
        </div>
    ); 

}

export default NoResults;